const config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENTID,
  audience: import.meta.env.VITE_AUTH0_AUDIENCE,
  scope: 'openid profile email offline_access',
  redirect_uri: '/',
}
export default config
